import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { languageHelper } from "../../../config/helperFunctions";

function ViewFoodItems({ currency }) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [error, setError] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    const fetchData = () => {
      axios
        .get(`${apiKey}/api/rms/admin/foodMenus/${id}`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => {
          setError(err.resposne.data.message);
        })
        .finally(() => {
          setPageLoading(false);
        });
    };

    handleCSRF(fetchData);
  }, [id, user?.token]);

  if (error) {
    return (
      <div
        className="flex items-center p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50"
        role="alert"
      >
        <svg
          className="flex-shrink-0 inline w-4 h-4 me-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
        </svg>
        <span className="sr-only">Info</span>
        <div>{error}</div>
      </div>
    );
  }

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">
              {languageHelper("Food Menu Details")}
            </h1>
          </div>
        </div>
        <div className="w-full">
          <div className="w-full grid grid-cols-4 gap-y-4">
            <div>
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Name")}
              </h2>
              <p className="text-gray-700 text-sm">{data.name}</p>
            </div>
            <div>
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Name Arabic")}
              </h2>
              <p className="text-gray-700 text-sm">{data.name_arabic}</p>
            </div>
            <div>
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Category")}
              </h2>
              <p className="text-gray-700 text-sm">
                {data.category.category_name}
              </p>
            </div>
            <div>
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Sub Category")}
              </h2>
              <p className="text-gray-700 text-sm">
                {data.sub_category?.sub_category_name}
              </p>
            </div>
            <div>
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Sale Price")}
              </h2>
              <p className="text-gray-700 text-sm">{data.sale_price} - {currency.value || "S.R"}</p>
            </div>
            {data.delivery_companies && data.delivery_companies.map((company) => (
              <div>
                <h2 className="text-d-bg-text text-xl">
                  {company.company.company_name}
                </h2>
                <p className="text-gray-700 text-sm">
                  {company.sale_price}
                </p>
              </div>
            ))}
            <div>
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Is it Veg Item?")}
              </h2>
              <p className="text-gray-700 text-sm">
                {data.veg_item === "no" ? "No" : "Yes"}
              </p>
            </div>
            <div>
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Is it Beverage?")}
              </h2>
              <p className="text-gray-700 text-sm">
                {data.beverage_item === "no" ? "No" : "Yes"}
              </p>
            </div>
            <div>
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Is it Bar Item?")}
              </h2>
              <p className="text-gray-700 text-sm">
                {data.bar_item === "no" ? "No" : "Yes"}
              </p>
            </div>
            <div>
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Tax Method")}
              </h2>
              <p className="text-gray-700 text-sm">
                {data.tax_method === "inclusive" ? "Inclusive" : "Exclusive"}
              </p>
            </div>
            <div>
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Vat Percentage")}
              </h2>
              <p className="text-gray-700 text-sm">
                {parseFloat(data.vat.percentage)}%
              </p>
            </div>
            <div>
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Kot Print")}
              </h2>
              <p className="text-gray-700 text-sm">
                {data.kot_print === "no" ? "No" : "Yes"}
              </p>
            </div>
            <div>
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Description")}
              </h2>
              <p className="text-gray-700 text-sm">{data.description}</p>
            </div>
            <div className="row-span-2">
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Logo Image")}
              </h2>
              <p className="text-gray-700 text-sm">Name</p>
            </div>
            <div>
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Code")}
              </h2>
              <p className="text-gray-700 text-sm">{data.code}</p>
            </div>
            <div className="col-span-3">
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Is Tax Fix?")}
              </h2>
              <p className="text-gray-700 text-sm">
                {data.is_tax_fix === "no" ? "No" : "Yes"}
              </p>
            </div>
            <div className="row-span-2">
              <h2 className="text-d-bg-text text-xl">
                {languageHelper("Logo Image")}
              </h2>
              <img src={data.photo_url} alt="" />
            </div>
            <div className="col-span-3">
              <table className="w-full text-sm text-left rtl:text-right">
                <thead className="uppercase font-medium">
                  <tr>
                    <th className="px-6 py-3">{languageHelper("SN")}</th>
                    <th className="px-6 py-3">
                      {languageHelper("Ingredient")}
                    </th>
                    <th className="px-6 py-3">
                      {languageHelper("Consumption")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.ingredients.map((ing, index) => (
                    <tr key={index}>
                      <td className="px-6 py-1">{index + 1}</td>
                      <td className="px-6 py-1">{ing.ingredient.name}</td>
                      <td className="px-6 py-1">{ing.consumption}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <span className="w-full bg-d-bg-text h-1 my-2 inline-block"></span>
          <div className="flex gap-2">
            <Link
              className="bg-d-bg-text text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
              to={`/admin/foodMenus/AddItemForm/${id}`}
            >
              {languageHelper("Edit")}
            </Link>
            <button
              className="bg-d-bg-text text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
              type="button"
              onClick={() => navigate(-1)}
            >
              {languageHelper("Back")}
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ViewFoodItems;
